const _temp0 = require("../../intl/menu/ar-AE.json");
const _temp1 = require("../../intl/menu/bg-BG.json");
const _temp2 = require("../../intl/menu/cs-CZ.json");
const _temp3 = require("../../intl/menu/da-DK.json");
const _temp4 = require("../../intl/menu/de-DE.json");
const _temp5 = require("../../intl/menu/el-GR.json");
const _temp6 = require("../../intl/menu/en-US.json");
const _temp7 = require("../../intl/menu/es-ES.json");
const _temp8 = require("../../intl/menu/et-EE.json");
const _temp9 = require("../../intl/menu/fi-FI.json");
const _temp10 = require("../../intl/menu/fr-FR.json");
const _temp11 = require("../../intl/menu/he-IL.json");
const _temp12 = require("../../intl/menu/hr-HR.json");
const _temp13 = require("../../intl/menu/hu-HU.json");
const _temp14 = require("../../intl/menu/it-IT.json");
const _temp15 = require("../../intl/menu/ja-JP.json");
const _temp16 = require("../../intl/menu/ko-KR.json");
const _temp17 = require("../../intl/menu/lt-LT.json");
const _temp18 = require("../../intl/menu/lv-LV.json");
const _temp19 = require("../../intl/menu/nb-NO.json");
const _temp20 = require("../../intl/menu/nl-NL.json");
const _temp21 = require("../../intl/menu/pl-PL.json");
const _temp22 = require("../../intl/menu/pt-BR.json");
const _temp23 = require("../../intl/menu/pt-PT.json");
const _temp24 = require("../../intl/menu/ro-RO.json");
const _temp25 = require("../../intl/menu/ru-RU.json");
const _temp26 = require("../../intl/menu/sk-SK.json");
const _temp27 = require("../../intl/menu/sl-SI.json");
const _temp28 = require("../../intl/menu/sr-SP.json");
const _temp29 = require("../../intl/menu/sv-SE.json");
const _temp30 = require("../../intl/menu/tr-TR.json");
const _temp31 = require("../../intl/menu/uk-UA.json");
const _temp32 = require("../../intl/menu/zh-CN.json");
const _temp33 = require("../../intl/menu/zh-TW.json");
module.exports = {
  "ar-AE": _temp0,
  "bg-BG": _temp1,
  "cs-CZ": _temp2,
  "da-DK": _temp3,
  "de-DE": _temp4,
  "el-GR": _temp5,
  "en-US": _temp6,
  "es-ES": _temp7,
  "et-EE": _temp8,
  "fi-FI": _temp9,
  "fr-FR": _temp10,
  "he-IL": _temp11,
  "hr-HR": _temp12,
  "hu-HU": _temp13,
  "it-IT": _temp14,
  "ja-JP": _temp15,
  "ko-KR": _temp16,
  "lt-LT": _temp17,
  "lv-LV": _temp18,
  "nb-NO": _temp19,
  "nl-NL": _temp20,
  "pl-PL": _temp21,
  "pt-BR": _temp22,
  "pt-PT": _temp23,
  "ro-RO": _temp24,
  "ru-RU": _temp25,
  "sk-SK": _temp26,
  "sl-SI": _temp27,
  "sr-SP": _temp28,
  "sv-SE": _temp29,
  "tr-TR": _temp30,
  "uk-UA": _temp31,
  "zh-CN": _temp32,
  "zh-TW": _temp33
}